module.exports = __webpack_public_path__ + "static/media/like-line.25fd4168.svg";